export default "__VITE_PUBLIC_ASSET__274e88ce__"